import { useState, useEffect } from 'react';
import { useSessionHealthStore } from '../../lib/session-health';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  // Set by lib/api.ts when a token refresh fails for a transient reason
  // (network, 429, 5xx) — the session is kept and retried with backoff.
  const degraded = useSessionHealthStore((s) => s.degraded);
  // Set once that backoff schedule has run out of attempts. lib/api.ts
  // restarts it on the browser's `online` event, so the copy must not
  // promise a background retry that is no longer happening.
  const retriesExhausted = useSessionHealthStore((s) => s.retriesExhausted);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline && !degraded) return null;

  let message: string;
  if (offline) {
    message = "You're offline — some features may be unavailable";
  } else if (retriesExhausted) {
    message =
      "Couldn't reconnect to ClinikChat — check your connection or reload; we'll try again once you're back online";
  } else {
    message = 'Connection to ClinikChat is unstable — reconnecting in the background';
  }

  return (
    <div
      role="status"
      className="fixed left-0 right-0 top-0 z-[200] bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white shadow-md"
    >
      {message}
    </div>
  );
}
